import { create } from 'zustand';
import type { CatRecord, CatClassId, CatsResponse, RunCatUpdate } from '@cradle7/shared';

type CatState = {
  active: Record<CatClassId, CatRecord | null>;
  retired: CatRecord[];
};

type CatActions = {
  hydrateFromServer: (payload: CatsResponse) => void;
  applyRunUpdate: (update: RunCatUpdate) => void;
  reset: () => void;
};

const EMPTY_ACTIVE: Record<CatClassId, CatRecord | null> = {
  vanguard: null, netrunner: null, psyker: null, engineer: null,
};

const INITIAL: CatState = {
  active: { ...EMPTY_ACTIVE },
  retired: [],
};

export const useCatStore = create<CatState & CatActions>((set) => ({
  ...INITIAL,
  hydrateFromServer: (p) => {
    const active: Record<CatClassId, CatRecord | null> = { ...EMPTY_ACTIVE };
    for (const c of p.active) active[c.classId] = c;
    set({ active, retired: p.retired });
  },
  applyRunUpdate: (update) => set((s) => {
    const isRetired = update.retiredAt != null;
    const newCat: CatRecord = {
      classId: update.classId,
      livesRemaining: update.livesRemaining,
      scars: update.scars,
      mutations: update.mutations,
      runsPlayed: update.runsPlayed,
      createdAt: s.active[update.classId]?.createdAt ?? Date.now(),
      retiredAt: update.retiredAt ?? undefined,
    };
    if (isRetired) {
      return {
        active: { ...s.active, [update.classId]: null },
        retired: [newCat, ...s.retired],
      };
    }
    return { active: { ...s.active, [update.classId]: newCat } };
  }),
  reset: () => set({ active: { ...EMPTY_ACTIVE }, retired: [] }),
}));
